export default "__VITE_ASSET__20879183__"